export default "__VITE_ASSET__BFUsERTq__"